import React, { useState, useEffect, useCallback } from 'react';
import PasienLayout from './PasienLayout'; // 🟢 Path disesuaikan dengan file PasienLayout Anda
import axiosInstance from '../../api/axios';
import '../admin/Dashboard.css';
import './pasien-pages.css';

const STATUS_CFG = {
  pending_billing: { label: 'Tagihan Disiapkan',    bg: '#f0f9ff', color: '#0369a1' },
  billed:          { label: 'Tagihan Siap',         bg: '#fef3c7', color: '#b45309' },
  draft:           { label: 'Menunggu Konfirmasi',  bg: '#fef9c3', color: '#854d0e' },
  paid:            { label: 'Lunas',                bg: '#dcfce7', color: '#166534' },
  cancelled:       { label: 'Dibatalkan',           bg: '#fee2e2', color: '#991b1b' },
};

const fmtRupiah = (n) =>
  new Intl.NumberFormat('id-ID', {
    style: 'currency', currency: 'IDR', minimumFractionDigits: 0,
  }).format(n ?? 0);

const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString('id-ID', {
    day: '2-digit', month: 'short', year: 'numeric',
  }) : '-';

/* ── Status Badge ── */
function StatusBadge({ status }) {
  const cfg = STATUS_CFG[status] ?? { label: status, bg: '#f1f5f9', color: '#475569' };
  return (
    <span className="status-badge" style={{ backgroundColor: cfg.bg, color: cfg.color, padding: '4px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: 600, display: 'inline-block' }}>
      {cfg.label}
    </span>
  );
}

/* ─────────────────────────────────────────────────────────────
   Modal Detail Transaksi (Responsif / Action Sheet di Mobile)
───────────────────────────────────────────────────────────── */
function ModalDetailTransaksi({ item, onClose, isMobile }) {
  if (!item) return null;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)',
        backdropFilter: 'blur(2px)', zIndex: 10000,
        display: 'flex', alignItems: isMobile ? 'flex-end' : 'center', justifyContent: 'center',
        padding: isMobile ? 0 : 20,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff', 
          borderRadius: isMobile ? '20px 20px 0 0' : 16,
          boxShadow: '0 20px 60px rgba(0,0,0,.18)',
          width: '100%', 
          maxWidth: isMobile ? '100%' : 500, 
          maxHeight: isMobile ? '85vh' : '90vh', 
          overflowY: 'auto',
          display: 'flex', 
          flexDirection: 'column',
          paddingBottom: isMobile ? 'calc(20px + env(safe-area-inset-bottom))' : 0,
          animation: isMobile ? 'slideUp 0.3s ease-out' : 'none'
        }}
        onClick={e => e.stopPropagation()}
      >
        {!isMobile && <div style={{ height: 4, background: 'linear-gradient(90deg,#2563eb,#60a5fa)', borderRadius: '16px 16px 0 0' }} />}
        
        {/* Handle bar kecil penanda swipe di mobile */}
        {isMobile && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0 4px 0' }}>
            <div style={{ width: 40, height: 4, borderRadius: 2, background: '#cbd5e1' }} />
          </div>
        )}

        <div style={{ padding: isMobile ? '16px 20px 24px 20px' : '24px 28px' }}>
          
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
            <div>
              <p style={{ fontSize: 11, fontWeight: 700, color: '#3b82f6', textTransform: 'uppercase', letterSpacing: 1, margin: '0 0 4px 0' }}>Detail Transaksi</p>
              <h2 style={{ fontSize: isMobile ? 18 : 20, fontWeight: 800, color: '#0f172a', margin: 0 }}>
                {item.nomor_invoice || '-'}
              </h2>
            </div>
            <button
              onClick={onClose}
              style={{ background: 'none', border: 'none', fontSize: 24, color: '#94a3b8', cursor: 'pointer', padding: 4, lineHeight: 1 }}
            >
              ×
            </button>
          </div>

          <div style={{
            background: '#f8fafc', border: '1px solid #e2e8f0',
            borderRadius: 10, padding: '14px', marginBottom: 20, fontSize: 13,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <span style={{ color: '#64748b' }}>Dokter</span>
              <strong style={{ color: '#0f172a', textAlign: 'right' }}>{item.pendaftaran?.dokter?.nama || '-'}</strong>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: '#64748b' }}>Tanggal</span>
              <strong style={{ color: '#0f172a' }}>{fmtDate(item.created_at)}</strong>
            </div>
          </div>

          <div style={{ marginBottom: 24 }}>
            <h4 style={{ fontSize: 14, fontWeight: 700, color: '#1e293b', marginBottom: 12 }}>Rincian Tagihan</h4>
            {(item.items && item.items.length > 0) ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {item.items.map((it, idx) => {
                  const subtotal = (parseFloat(it.harga_satuan) || 0) * (parseInt(it.qty) || 0);
                  return (
                    <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, borderBottom: '1px dashed #e2e8f0', paddingBottom: 8, alignItems: 'center' }}>
                      <span style={{ color: '#475569', paddingRight: 8 }}>{it.nama_snapshot} <span style={{ color: '#94a3b8', fontSize: 12 }}>×{Number(it.qty)}</span></span>
                      <strong style={{ color: '#0f172a', whiteSpace: 'nowrap' }}>{fmtRupiah(subtotal)}</strong>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p style={{ fontSize: 13, color: '#94a3b8', fontStyle: 'italic', margin: 0 }}>Detail tindakan belum tersedia.</p>
            )}
          </div>

          <div style={{
            borderTop: '2px solid #e2e8f0', paddingTop: 16,
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}>
            <span style={{ fontWeight: 600, color: '#1e293b', fontSize: 14 }}>Total Pembayaran</span>
            <span style={{ fontSize: isMobile ? 18 : 20, fontWeight: 800, color: '#166534' }}>
              {fmtRupiah(item.total)}
            </span>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', marginTop: 24 }}>
            <button
              onClick={onClose}
              style={{
                padding: '12px', borderRadius: 8, border: 'none',
                background: '#e2e8f0', color: '#475569',
                fontSize: 14, fontWeight: 600, cursor: 'pointer', textAlign: 'center'
              }}
            >
              Tutup Window
            </button>
          </div>
          
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   Halaman Utama: Pembayaran Pasien
───────────────────────────────────────────────────────────── */
export default function PembayaranPasien() {
  const [transaksi,   setTransaksi]   = useState([]);
  const [modalDetail, setModalDetail] = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [error,       setError]       = useState('');
  const [isMobile,    setIsMobile]    = useState(false);

  // Sinkronisasi pendeteksi ukuran layar gawai secara real-time
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchData = useCallback(async () => {
    setError('');
    try {
      const trxRes = await axiosInstance.get('/pasien/transaksi').catch(() => ({ data: { data: [] } }));
      const trxRaw = trxRes.data?.data?.data ?? trxRes.data?.data ?? trxRes.data ?? [];
      setTransaksi(Array.isArray(trxRaw) ? trxRaw : []);
    } catch (err) {
      setError(err.response?.data?.message ?? 'Gagal memuat data.');
    }
  }, []);

  useEffect(() => {
    (async () => { setLoading(true); await fetchData(); setLoading(false); })();
  }, [fetchData]);

  const totalPaid = transaksi.filter(t => t.status === 'paid').length;

  return (
    // 🟢 DIBUNGKUS menggunakan shell PasienLayout Anda agar Bottom Nav muncul otomatis
    <PasienLayout>
      <div className="w-full p-4 md:p-6" style={{ width: '100%', boxSizing: 'border-box' }}>

        <header className="pasien-page-header" style={{ marginBottom: '20px' }}>
          <h1 style={{ fontSize: isMobile ? '1.5rem' : '2rem', margin: '0 0 4px 0', fontWeight: 700, color: '#1e293b' }}>
            Riwayat Transaksi
          </h1>
          <p style={{ margin: 0, color: '#64748b', fontSize: '14px' }}>
            Daftar riwayat pembayaran Anda di klinik.
          </p>
        </header>

        {/* Statistik Ringkas */}
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 20 }}>
          {[
            { label: 'Total Transaksi',       value: transaksi.length, color: '#0f172a' },
            { label: 'Sudah Lunas',           value: totalPaid,        color: '#166534' },
          ].map(s => (
            <div key={s.label} className="pasien-table-wrap" style={{ padding: 14, backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
              <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px' }}>{s.label}</div>
              <div style={{ fontSize: '22px', fontWeight: 700, color: s.color }}>{s.value}</div>
            </div>
          ))}
        </div>

        {error && (
          <div className="pasien-banner pasien-banner--error" role="alert" style={{ padding: '12px', borderRadius: '8px', marginBottom: '20px', backgroundColor: '#fee2e2', color: '#991b1b', fontSize: '14px' }}>
            {error}
          </div>
        )}

        {loading ? (
          <div className="loading" style={{ textAlign: 'center', padding: '40px 0', color: '#64748b' }}>Memuat data…</div>
        ) : (
          transaksi.length === 0 ? (
            <div className="pasien-empty" style={{ textAlign: 'center', padding: '40px 20px', color: '#64748b', border: '1px dashed #cbd5e1', borderRadius: '12px', backgroundColor: '#f8fafc' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>📜</div>
              <strong style={{ display: 'block', marginBottom: 8, color: '#334155' }}>
                Belum ada transaksi
              </strong>
              <p style={{ margin: 0, color: '#64748b', fontSize: '14px' }}>
                Riwayat pembayaran akan tampil di sini.
              </p>
            </div>
          ) : (
            <div>
              {/* TAMPILAN DESKTOP (Tabel Konvensional) */}
              {!isMobile && (
                <div className="pasien-table-container" style={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                  <table className="pasien-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ textAlign: 'left', borderBottom: '1px solid #e2e8f0' }}>
                        <th style={{ padding: '12px' }}>No. Invoice</th>
                        <th style={{ padding: '12px' }}>Tanggal</th>
                        <th style={{ padding: '12px' }}>Total Tagihan</th>
                        <th style={{ padding: '12px' }}>Status</th>
                        <th style={{ padding: '12px' }}>Lunas Pada</th>
                        <th style={{ padding: '12px' }}>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transaksi.map(t => (
                        <tr key={t.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                          <td style={{ padding: '12px' }}>
                            <span style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 13, color: '#2563eb' }}>
                              {t.nomor_invoice ?? '-'}
                            </span>
                          </td>
                          <td style={{ padding: '12px' }}>{fmtDate(t.created_at)}</td>
                          <td style={{ padding: '12px', fontWeight: 700 }}>
                            {t.total > 0 ? fmtRupiah(t.total) : <span style={{ color: '#94a3b8', fontWeight: 400, fontSize: 12 }}>Belum dihitung</span>}
                          </td>
                          <td style={{ padding: '12px' }}><StatusBadge status={t.status} /></td>
                          <td style={{ padding: '12px', color: '#64748b', fontSize: 13 }}>
                            {t.paid_at ? fmtDate(t.paid_at) : '-'}
                          </td>
                          <td style={{ padding: '12px' }}>
                            <button
                              onClick={() => setModalDetail(t)}
                              style={{
                                padding: '6px 13px', borderRadius: 7, border: '1px solid #cbd5e1',
                                background: '#f8fafc', color: '#475569',
                                fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
                              }}
                            >
                              👁️ Lihat Detail
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* TAMPILAN MOBILE (Stacked Minimalis Card) */}
              {isMobile && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {transaksi.map(t => (
                    <div key={t.id} style={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '14px', boxSizing: 'border-box' }}>
                      
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <span style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: '13px', color: '#2563eb' }}>
                          {t.nomor_invoice ?? '-'}
                        </span>
                        <StatusBadge status={t.status} />
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '13px', color: '#334155', borderBottom: '1px dashed #f1f5f9', paddingBottom: '10px', marginBottom: '10px' }}>
                        <div><strong style={{ color: '#64748b' }}>Tanggal:</strong> {fmtDate(t.created_at)}</div>
                        <div>
                          <strong style={{ color: '#64748b' }}>Total:</strong>{' '}
                          <span style={{ fontWeight: 700, color: '#0f172a' }}>
                            {t.total > 0 ? fmtRupiah(t.total) : 'Belum dihitung'}
                          </span>
                        </div>
                        {t.paid_at && (
                          <div style={{ fontSize: '12px', color: '#166534' }}>
                            <strong>Lunas:</strong> {fmtDate(t.paid_at)}
                          </div>
                        )}
                      </div>

                      <button
                        onClick={() => setModalDetail(t)}
                        style={{
                          width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #cbd5e1',
                          background: '#f8fafc', color: '#475569', fontSize: '12px', fontWeight: 600, cursor: 'pointer'
                        }}
                      >
                        👁️ Periksa Rincian Nota
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )
        )}

        {/* Global Modal Injection */}
        {modalDetail && (
          <ModalDetailTransaksi
            item={modalDetail}
            onClose={() => setModalDetail(null)}
            isMobile={isMobile}
          />
        )}

      </div>
      
      {/* CSS Tambahan Khusus Transisi Modal Geser Naik di Mobile */}
      {isMobile && (
        <style>{`
          @keyframes slideUp {
            from { transform: translateY(100%); }
            to { transform: translateY(0); }
          }
        `}</style>
      )}
    </PasienLayout>
  );
}